import { getIgnoredUrls, getNormalizeRules, setIgnoredUrls, setNormalizeRules } from './prefs';
import { updateUrlNormalizationCache, defaultNormalizeRegexes, defaultIgnoredSubstrings } from './urlNormalizationPrefs';
import { logger } from '../utils/logger';

export async function loadPrefsFromDB() {
  const loadedIgnored = await getIgnoredUrls();
  let finalIgnored = loadedIgnored;
  if (!loadedIgnored) {
    // Write defaults to DB if not present
    finalIgnored = defaultIgnoredSubstrings;
    await setIgnoredUrls(finalIgnored);
  }

  const loadedRules = await getNormalizeRules();
  let finalRules = loadedRules;
  if (!loadedRules) {
    // Write defaults to DB
    finalRules = defaultNormalizeRegexes;
    await setNormalizeRules(finalRules);
  }
  
  if (finalIgnored && finalRules) {
     updateUrlNormalizationCache(finalIgnored, finalRules);
  }
  
  logger.info('Prefs loaded', { finalIgnored, finalRules });
}
